<template>
    <div>
        <!-- Loading Placeholder -->
        <div v-if="!dataLoaded">Loading...</div>
        <button @click="EditMode = !EditMode">{{EditMode?'Cancel Edit':'Edit'}}</button>

        <!-- Edit Mode -->
        <div v-if="dataLoaded">
            <div v-if="EditMode" on.submit.prevent>
                <div class="row">
                    <div class="column">
                        <input type="hidden" v-model="product.author">
                        <label>Product</label><input type="text" v-model="product.name">
                        <label>Created By</label><input type="text" v-model="product.authorName" disabled>
                        <label>Price ($)</label><input type="number" step="0.01" v-model="product.price">
                        <label>GST</label><input type="checkbox" v-model="product.gst">
                    </div>
                    <div class="column">
                        <label>Description</label>
                        <textarea v-model="product.description"></textarea>
                        <label>Notes</label>
                        <textarea v-model="product.notes"></textarea>
                    </div>
                </div>
                <button @click="updateProduct">Save</button>
            </div>
            
            <!-- Display Info -->
            <div v-else>
                <!-- Product Details -->
                <div class="row">
                    <div class="column">
                        <h3>{{product.name}}</h3>
                        <p><b>Quantiity Available</b> {{product.totalStock}}</p>
                        <p><b>Price</b> ${{product.price.toFixed(2)}}, GST {{(product.gst == 1) ? 'applicable' : 'exempt'}}</p>
                        <p><b>Created</b> {{product.created}} by <router-link :to="'/users/'+product.author">{{product.authorName}}</router-link></p>
                    </div>
                    <div class="column">
                        <p><b>Description</b></p>
                        <p>{{product.description}}</p>
                        <p><b>Notes</b></p>
                        <p>{{product.notes}}</p>
                    </div>
                </div>
                
                <!-- Product History -->
                <h3>History</h3>
                <table>
                    <!-- Header Row -->
                    <tr>
                        <th>Who</th>
                        <th>Quantity</th>
                        <th>Notes</th>
                        <th>Date</th>
                    </tr>

                    <!-- Add Log Row -->
                    <tr>
                        <th>Add new Entry</th>
                        <td><input type="number" v-model="newLog.qty"></td>
                        <td><input type="text" v-model="newLog.notes"></td>
                        <td><button @click="addNewInteraction">Update Quantity</button></td>
                    </tr>

                    <!-- Entry Rows -->
                    <tr v-for="logEntry in logs" :key="logEntry.id">
                        <td><router-link :to="'/users/'+logEntry.user">{{logEntry.authorName}}</router-link></td>
                        <td>{{ (logEntry.qty>=0) ? 'Added' : 'Removed'}} {{Math.abs(logEntry.qty)}}</td>
                        <td>{{logEntry.timelog | date}}</td>
                        <td>{{logEntry.notes}}</td>
                    </tr>
                </table>

            </div>
        </div><!-- Data Loaded -->
    </div>
</template>

<script>
import { CallApi } from '../Utilities'
export default {
    name: 'StockDetails',
    data: function () {
        return {
            dataLoaded: false,
            product: [],
            logs: [],
            EditMode: false,
            newLog: {}
        }
    },
    methods: {
        updateProduct: async function() {
            await CallApi('POST', `/inventory/${this.$route.params.id}`, this.product)
            this.fetchData()
        },
        addNewInteraction: async function() {
            await CallApi('POST', `/inventory/${this.$route.params.id}/adjust-stock`, this.newLog)
            this.newLog = {}
            this.fetchData()
        },
        fetchData: async function() {
            const apiResponse = await CallApi('GET', `/inventory/${this.$route.params.id}`)
            this.product = apiResponse.product
            this.logs = apiResponse.log
            this.dataLoaded = true
            this.EditMode = false
        }
    },
    mounted: function() {
        this.fetchData()
    }
}
</script>